var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutopluscondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.081,
    height: 50,
    viewBox: "0 0 151.081 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132670",
    "data-name": "Group 132670",
    transform: "translate(-363 -570)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buliding",
    transform: "translate(464.081 570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91218",
    "data-name": "Path 91218",
    d: "M50.231,23.288H2.269a1.019,1.019,0,0,1,0-2.038H50.231a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(-1.25 26.712)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91219",
    "data-name": "Path 91219",
    d: "M12.862,1.25H36.842c6.843,0,10.612,3.769,10.612,10.612V50.231a1.019,1.019,0,0,1-1.019,1.019H3.269A1.019,1.019,0,0,1,2.25,50.231V11.862C2.25,5.019,6.019,1.25,12.862,1.25ZM45.415,49.212V11.862a9.127,9.127,0,0,0-1.851-6.117C42.158,4.115,39.9,3.288,36.842,3.288H12.862c-3.054,0-5.315.826-6.723,2.456a9.127,9.127,0,0,0-1.851,6.117v37.35Z",
    transform: "translate(0.148 -1.25)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91220",
    "data-name": "Path 91220",
    d: "M14.463,17.788H7.269a1.019,1.019,0,1,1,0-2.038h7.194a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(5.74 19.022)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91221",
    "data-name": "Path 91221",
    d: "M21.463,17.788H14.269a1.019,1.019,0,0,1,0-2.038h7.194a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(15.527 19.022)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91222",
    "data-name": "Path 91222",
    d: "M14.463,13.288H7.269a1.019,1.019,0,0,1,0-2.038h7.194a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(5.74 12.731)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91223",
    "data-name": "Path 91223",
    d: "M21.463,13.288H14.269a1.019,1.019,0,0,1,0-2.038h7.194a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(15.527 12.731)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91224",
    "data-name": "Path 91224",
    d: "M14.463,8.788H7.269a1.019,1.019,0,1,1,0-2.038h7.194a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(5.74 6.439)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91225",
    "data-name": "Path 91225",
    d: "M21.463,8.788H14.269a1.019,1.019,0,0,1,0-2.038h7.194a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(15.527 6.439)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132490",
    "data-name": "Group 132490",
    transform: "translate(430.069 585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95933",
    "data-name": "Path 95933",
    d: "M-9209.957-10370.245v19.013",
    transform: "translate(9219.464 10370.245)",
    fill: "none",
    stroke: "#09143a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95934",
    "data-name": "Path 95934",
    d: "M0,0V19.012",
    transform: "translate(19.012 9.506) rotate(90)",
    fill: "none",
    stroke: "#09143a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "car",
    transform: "translate(363 570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91190",
    "data-name": "Path 91190",
    d: "M15.5,2.08H33.066c3.154,0,5.433.763,6.968,2.333A10.453,10.453,0,0,1,42.47,9.794L45.3,23.331a1.019,1.019,0,0,1-1,1.228H4.269a1.019,1.019,0,0,1-1-1.228L6.1,9.8A10.455,10.455,0,0,1,8.535,4.413C10.07,2.843,12.349,2.08,15.5,2.08ZM43.046,22.521,40.475,10.213a8.7,8.7,0,0,0-1.9-4.375c-1.131-1.157-2.934-1.72-5.51-1.72H15.5c-2.577,0-4.379.563-5.51,1.72a8.7,8.7,0,0,0-1.9,4.376L5.523,22.521Z",
    transform: "translate(1.75 -2.08)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91191",
    "data-name": "Path 91191",
    d: "M47.2,39.809H42.5c-3.428,0-4.031-1.808-4.515-3.261l-.514-1.54c-.672-1.968-.923-2.7-3.778-2.7H20.881a4.05,4.05,0,0,0-2.794.732,4.8,4.8,0,0,0-.993,2l-.5,1.514C16.106,38,15.5,39.809,12.075,39.809h-4.7a6.175,6.175,0,0,1-4.561-2,5.968,5.968,0,0,1-1.533-4.565l1.4-15.235c.178-1.9.457-3.883,1.724-5.386C5.766,11,7.966,10.25,11.324,10.25H43.248c3.358,0,5.558.753,6.921,2.37A9.407,9.407,0,0,1,51.894,18l1.4,15.238a5.967,5.967,0,0,1-1.533,4.563A6.175,6.175,0,0,1,47.2,39.809Zm-26.32-9.544h12.81c4.312,0,4.99,1.984,5.707,4.085l.011.033,0,.007.5,1.514a3.431,3.431,0,0,0,.674,1.4,2.812,2.812,0,0,0,1.907.472h4.7a4.132,4.132,0,0,0,3.053-1.338,3.874,3.874,0,0,0,1.011-3l-1.4-15.239c-.343-3.673-.959-5.9-6.616-5.9H11.324c-5.657,0-6.273,2.231-6.616,5.906l-1.4,15.235a3.875,3.875,0,0,0,1.011,3,4.132,4.132,0,0,0,3.053,1.338h4.7a2.812,2.812,0,0,0,1.907-.472,3.431,3.431,0,0,0,.674-1.4l.5-1.514C15.805,32.456,16.536,30.265,20.881,30.265Z",
    transform: "translate(-1.252 10.191)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91192",
    "data-name": "Path 91192",
    d: "M5.771,9.288h-2.5a1.019,1.019,0,0,1,0-2.038h2.5a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(0.248 5.685)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91193",
    "data-name": "Path 91193",
    d: "M22.771,9.288h-2.5a1.019,1.019,0,1,1,0-2.038h2.5a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(25.781 5.685)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91194",
    "data-name": "Path 91194",
    d: "M12.269,9.292A1.019,1.019,0,0,1,11.25,8.273v-5a1.019,1.019,0,0,1,2.038,0v5A1.019,1.019,0,0,1,12.269,9.292Z",
    transform: "translate(13.765 -1.825)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91195",
    "data-name": "Path 91195",
    d: "M18.275,6.288H10.769a1.019,1.019,0,0,1,0-2.038h7.506a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(11.512 1.179)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91196",
    "data-name": "Path 91196",
    d: "M13.775,16.288H6.269a1.019,1.019,0,0,1,0-2.038h7.506a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(4.754 16.198)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91197",
    "data-name": "Path 91197",
    d: "M22.775,16.288H15.269a1.019,1.019,0,0,1,0-2.038h7.506a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(18.271 16.198)",
    fill: "#09143a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutopluscondo);
export default __webpack_public_path__ + "static/media/autopluscondo.4acb895162b38b56c211ea77386bfba7.svg";
export { ForwardRef as ReactComponent };